/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BuilderFormSchemaFactory, FormRootSchema, FormState, FormStateSchema } from '@gh/builder-shared';
import { TextTypes } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { getControlValue, getRootControl } from '@gh/core-ui';
import { compact, isNil, trim } from 'lodash';
import { CommunicationData } from '../../resources/model/contact-details-communications.model';

@Injectable()
export class ContactDetailsSharedCommunicationListFormStateFactory {
  constructor(private schemaFactory: BuilderFormSchemaFactory) {

  }

  create(): ContactDetailsSharedCommunicationListFormState {
    return new ContactDetailsSharedCommunicationListFormState(this.schemaFactory);
  }
}

export class ContactDetailsSharedCommunicationListFormState extends FormState<CommunicationData> {

  constructor(private schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  get rootForm(): FormGroup {
    return <FormGroup>getRootControl(this.group);
  }

  get gDriveFolderId(): ID {
    return getControlValue(this.group, 'gDriveFolderId');
  }

  get validEmails(): string {
    const { email, otherEmails } = this.rootForm.value.common;

    return compact([email, ...(otherEmails || '').split(';').map(trim)])
      .filter((e) => isNil(TextTypes.Email.validate(e)))
      .join(';');
  }

  protected buildSchema(_: CommunicationData, { root }: FormStateSchema): FormRootSchema {
    return root({
      children: {
        gDriveFolderId: void 0,
        gDriveUrl: void 0,
        communications: void 0,
      },
    });
  }
}
